import { Flex, RadioFieldGroup, Typography } from '@iheartjane/reefer';

import type { ConditionSelectionType } from './conditions.types';

export interface ConditionSelectionTypeRadioProps {
  /** What is being selected, ex "products". Fills in both option labels */
  noun: string;

  onChange(selectionType: ConditionSelectionType): void;

  value: ConditionSelectionType;
}

/**
 * The include/exclude choice, shared by the built-in condition modal and the
 * consumer-supplied pickers, so both read the same wording.
 */
export const ConditionSelectionTypeRadio = ({
  noun,
  onChange,
  value,
}: ConditionSelectionTypeRadioProps) => (
  <Flex gap={16}>
    <Typography variant="body-semibold">
      Choose the type of selection:
    </Typography>
    <RadioFieldGroup
      name="condition-selection-type"
      row
      externalValue={value}
      onChange={(selected: ConditionSelectionType) => onChange(selected)}
      options={[
        { id: 'includes', label: `Include ${noun}`, value: 'includes' },
        { id: 'excludes', label: `Exclude ${noun}`, value: 'excludes' },
      ]}
    />
  </Flex>
);
